export var ImageContainerShape;
(function (ImageContainerShape) {
    ImageContainerShape[ImageContainerShape["Circle"] = 0] = "Circle";
    ImageContainerShape[ImageContainerShape["Rectangle"] = 1] = "Rectangle";
    ImageContainerShape[ImageContainerShape["RoundedRectangle"] = 2] = "RoundedRectangle";
})(ImageContainerShape || (ImageContainerShape = {}));
//# sourceMappingURL=ImageOptions.js.map